import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import './App.css';

const Form = () => {
  const [recaptchaValue, setRecaptchaValue] = useState(null);

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;

    if (!recaptchaValue) {
      alert("Please verify that you are not a robot.");
      return;
    }

    if (form.checkValidity()) {
      const data = {
        "First Name": form.nameForm.value,
        "Last Name": form.lastnameForm.value,
        "Sex": form.sexForm.value,
        "Age Range": form.ageForm.value,
        "Email": form.emailForm.value,
        "Agree": form.agreeForm.checked ? "Yes" : "No",
        "reCAPTCHA": recaptchaValue,
      };

      fetch("https://sheetdb.io/api/v1/liegf4rqubtqt", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then(() => {
          alert("Thank you! Enjoy the best prices on sportswear at sportfan.co.nz");
          window.location.href = "https://sportsfan.co.nz/";
        })
        .catch((err) => {
          console.error(err);
          alert("There was an error submitting the form.");
        });
    }
  };

  return (
    <div className="containerForm">
      {/* LOGO */}
      <div className="logoContainer">
        <img
          src="img/logoSF.svg"
          alt="SportsFan Logo"
          className="sportsfan"
        />
      </div>

      <form id="promoForm" onSubmit={handleSubmit}>
        <h2>Join SportsFan!</h2>

        <label htmlFor="nameForm">First Name *</label>
        <input type="text" id="nameForm" name="nameForm" required />

        <label htmlFor="lastnameForm">Last Name *</label>
        <input type="text" id="lastnameForm" name="lastnameForm" required />

        <label htmlFor="sexForm">Sex *</label>
        <select id="sexForm" name="sexForm" required>
          <option value="">Select...</option>
          <option value="female">Female</option>
          <option value="male">Male</option>
          <option value="other">Other</option>
        </select>

        <label htmlFor="ageForm">Age Range *</label>
        <select id="ageForm" name="ageForm" required>
          <option value="">Select...</option>
          <option value="18-25">18–25</option>
          <option value="26-35">26–35</option>
          <option value="36-45">36–45</option>
          <option value="46-56">46–56</option>
          <option value="57+">57+</option>
        </select>

        <label htmlFor="emailForm">Email *</label>
        <input type="email" id="emailForm" name="emailForm" required />

        <div className="checkboxForm">
          <input type="checkbox" id="agreeForm" name="agreeForm" required />
          <label htmlFor="agreeForm">
            I agree to receive news, promotions, and special offers from SportsFan.
          </label>
        </div>

        {/* reCAPTCHA */}
        <div className="recaptchaContainer">
          <ReCAPTCHA
            // sitekey="6Le0MU8oAAAAAM4zQ8AMbN6ylaqWJP8w-3MwrqMA"
            sitekey="6LfI5AksAAAAAE-tXaa4naMVXzDtW0_Ft212I9gi"
            onChange={handleRecaptchaChange}
          />
        </div>

        <button type="submit" id="sendForm">
          Send
        </button>
      </form>

    </div>
  );
};

export default Form;
